/* unplugin-vue-components disabled */import { render } from "./dragcontent.vue?vue&type=template&id=09b29c50&scoped=true"
import script from "./dragcontent.vue?vue&type=script&lang=js"
export * from "./dragcontent.vue?vue&type=script&lang=js"

import "./dragcontent.vue?vue&type=style&index=0&id=09b29c50&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b29c50"]])

export default __exports__